export default "__VITE_ASSET__BrpR0$rV__"